export type ProductCode = 'qutime' | 'pureoa';

export interface ProductMetadata {
  productName: string;
  description: string;
  favicon: string;
}

export const PRODUCT_METADATA: Record<ProductCode, ProductMetadata> = {
  qutime: {
    productName: 'QuTime',
    description: 'Mobile attendance with geofencing and face verification for small businesses.',
    favicon: '/favicon-qutime.ico',
  },
  pureoa: {
    productName: 'PureOA',
    description: 'Approval workflows, request forms, and follow-up tasks for small businesses.',
    favicon: '/favicon-pureoa.ico',
  },
};

export function resolveProductCode(value: string | null | undefined): ProductCode {
  return value?.toLowerCase() === 'pureoa' ? 'pureoa' : 'qutime';
}

export function metadataForProduct(value: string | null | undefined): ProductMetadata {
  return PRODUCT_METADATA[resolveProductCode(value)];
}
